'use client';

import { useEffect } from 'react';

const ZendeskSnippetSrc =
    'https://static.zdassets.com/ekr/snippet.js?key=7ad04258-0f0b-4235-8598-c01e43c85815';

const OpenMessenger = () => {
    if (typeof window.zE !== 'function') {
        console.warn('Zendesk is not ready yet.');
        return;
    }

    try {
        window.zE('messenger', 'show');
        window.zE('messenger', 'open');
    } catch (error) {
        console.warn('Zendesk messenger open failed', error);
    }

    try {
        window.zE('webWidget', 'show');
        window.zE('webWidget', 'open');
    } catch {}
};

const OpenWidget = () => {
    if (typeof window.zE !== 'function') {
        console.warn('Zendesk is not ready yet.');
        return;
    }

    try {
        window.zE('webWidget', 'show');
        window.zE('webWidget', 'open');
    } catch (error) {
        console.warn('Zendesk widget open failed', error);
    }
};

const ZendeskAutoOpen = () => {
    useEffect(() => {
        // Register early helpers so buttons clicking them don't throw errors
        window.openZendeskMessenger = OpenMessenger;
        window.openZendeskWidget = OpenWidget;

        if (typeof window.zE === 'function') {
            OpenMessenger();
            return;
        }

        const loadZendeskScript = () => {
            if (document.getElementById('ze-snippet')) {
                // Already injected, make sure callbacks are registered and opened
                window.openZendeskMessenger = OpenMessenger;
                window.openZendeskWidget = OpenWidget;
                OpenMessenger();
                return;
            }

            const script = document.createElement('script');
            script.id = 'ze-snippet';
            script.src = ZendeskSnippetSrc;
            script.async = true;
            script.onload = () => {
                window.openZendeskMessenger = OpenMessenger;
                window.openZendeskWidget = OpenWidget;
                OpenMessenger();
            };

            document.head.appendChild(script);
        };

        if (document.readyState === 'complete') {
            loadZendeskScript();
        } else {
            window.addEventListener('load', loadZendeskScript);
        }

        return () => {
            window.removeEventListener('load', loadZendeskScript);
        };
    }, []);

    return null;
};

export default ZendeskAutoOpen;
